import HeartOutlined from '../../src/legacy/HeartOutlined.tsx';
export default HeartOutlined;
